<template>
  <span class="sl-avatar" :style="showFallback ? { backgroundImage: gradient } : null" :title="name">
    <img v-if="!showFallback" :src="src" :alt="name" @error="failed = true" />
    <svg v-else class="sl-avatar__letter" viewBox="0 0 40 40" aria-hidden="true">
      <text x="20" y="27" text-anchor="middle">{{ initial }}</text>
    </svg>
  </span>
</template>

<script>
// Twitch CDN profile URLs go stale over time, so any avatar can 404. When that
// happens we draw a deterministic coloured circle with the user's initial —
// same name always gets the same colour.
const GRADIENTS = [
  'linear-gradient(135deg,#f2c14e,#e08a1e)',
  'linear-gradient(135deg,#e01f28,#8f1218)',
  'linear-gradient(135deg,#9146ff,#5a1fb0)',
  'linear-gradient(135deg,#4ea8f2,#1e5ee0)',
  'linear-gradient(135deg,#4ef2a8,#1ee07a)'
]

export default {
  name: 'user-avatar',
  props: {
    name: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      failed: false
    }
  },
  computed: {
    showFallback () {
      return !this.src || this.failed
    },
    initial () {
      const match = String(this.name).match(/[a-z0-9]/i)
      return match ? match[0].toUpperCase() : '?'
    },
    gradient () {
      const key = String(this.name) || '?'
      let hash = 0
      for (let i = 0; i < key.length; i++) {
        hash = (hash * 31 + key.charCodeAt(i)) >>> 0
      }
      return GRADIENTS[hash % GRADIENTS.length]
    }
  },
  watch: {
    // a fresh url deserves a fresh attempt
    src () {
      this.failed = false
    }
  }
}
</script>

<style scoped>
.sl-avatar {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
  background-color: var(--sl-surface);
  background-size: cover;
}

.sl-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.sl-avatar__letter {
  width: 100%;
  height: 100%;
  display: block;
}

.sl-avatar__letter text {
  font-family: var(--sl-font);
  font-size: 20px;
  font-weight: 800;
  fill: #0a0a0c;
}
</style>



// WEBPACK FOOTER //
// src/components/User-Avatar.vue